// extracted by mini-css-extract-plugin
export default {"wrapper":"Book_wrapper__11oyV","title":"Book_title__fOtEf"};